import script from "./EsportFixtureDoubleMarket.vue?vue&type=script&setup=true&lang=js"
export * from "./EsportFixtureDoubleMarket.vue?vue&type=script&setup=true&lang=js"

import "./EsportFixtureDoubleMarket.vue?vue&type=style&index=0&id=6f62c6f5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f62c6f5"]])

export default __exports__